/* eslint-disable @typescript-eslint/no-unnecessary-type-constraint */
import * as SepaCreditorIdentifier from '@shinetools/sepa-creditor-identifier';
import { isEmpty } from 'ramda';

import locales from '../locales';
import { Errors } from '../types';

function validateCreditorIdentifier(creditorIdentifier: string) {
  if (isEmpty(creditorIdentifier)) {
    return locales.formErrorEmptyField;
  }
  if (!SepaCreditorIdentifier.validate(creditorIdentifier)) {
    return locales.form.creditorIdentifier.errorInvalidIdentifier;
  }
  return null;
}

function validateCreditorName(creditorName: string) {
  if (isEmpty(creditorName)) {
    return locales.formErrorEmptyField;
  }
  return null;
}

function validateUniqueMandateReference(uniqueMandateReference: string) {
  if (isEmpty(uniqueMandateReference)) {
    return locales.formErrorEmptyField;
  }
  if (uniqueMandateReference.length > 35) {
    return locales.form.uniqueMandateReference.helpText;
  }
  return null;
}

interface Options {
  creditorIdentifier: string;
  creditorName: string;
  uniqueMandateReference: string;
}

export function validateForm({
  creditorIdentifier,
  creditorName,
  uniqueMandateReference,
}: Options): Errors {
  const errors: Errors = {};

  const validateField = <T>(
    fieldName: keyof Errors,
    value: T,
    validator: (value: T) => string | null,
  ) => {
    const errorMessage = validator(value);
    if (errorMessage) {
      errors[fieldName] = errorMessage;
    }
  };

  validateField(
    'creditorIdentifier',
    creditorIdentifier,
    validateCreditorIdentifier,
  );
  validateField('creditorName', creditorName, validateCreditorName);
  validateField(
    'uniqueMandateReference',
    uniqueMandateReference,
    validateUniqueMandateReference,
  );

  return errors;
}
